import {action, makeAutoObservable} from 'mobx';
import {api} from '../api/api';
import {EChannel, IRoute, IStyleguideRoute} from '../types/types';
import {IRootStore} from './RootStore';
import {channelMainPageFigmaIds} from './consts';

/**
 * Возвращает карту роутов и идентификаторов досок из Figma.
 */
export const getMapRoutAndBoardId = (routes: IStyleguideRoute[]): {
    [route: string]: IRoutesAndBoardsMapItem
} => {
    const map: {
        [route: string]: IRoutesAndBoardsMapItem
    } = {};
    const stack = [...routes];

    while (stack.length > 0) {
        const currentObj: IStyleguideRoute = stack.shift()!;
        if (currentObj.ID) {
            map['/' + currentObj.FULL_PATH] = {
                id: currentObj.ID,
                figmaId: currentObj.FIGMA_ID!,
            };

            /**
             * Кастомное добавление заглавных страниц раздела.
             */
            if (channelMainPageFigmaIds.includes(currentObj.FIGMA_ID!)) {

                map['/' + currentObj.FULL_PATH.split('/')[0]] = {
                    id: currentObj.ID,
                    figmaId: currentObj.FIGMA_ID!,
                };

                // Добавление в роуты.
               routes.push({
                   "ID": currentObj.ID,
                   "FIGMA_ID": currentObj.FIGMA_ID,
                   "NAME": "",
                   "PATH": "",
                   // Название канала, например Web.
                   "FULL_PATH": currentObj.FULL_PATH.split('/')[0]
               });
            }
        }
        if (currentObj.CHILDREN) {
            stack.unshift(...currentObj.CHILDREN);
        }
    }
    return map;
}

interface IRoutesAndBoardsMapItem {
    id: string,
    figmaId: string,
}

export interface IRoutesStore {
    routes: {
        [channelId: string]: IRoute;
    };
    /**
     * Карта роутов и идентификаторов досок из Figma.
     */
    routesAndBoardsMap: {
        [route: string]: IRoutesAndBoardsMapItem
    };
    /**
     * Загружает роуты.
     */
    loadRoute: (id: string, channelId: EChannel) => void;
    /**
     * Обработчик успешной загрузки роутов.
     */
    loadRouteSuccess: (channelId: EChannel) => (route: IRoute) => void;
    rootStore: IRootStore;
}

class RoutesStore implements IRoutesStore {
    routes: {
        [channelId: string]: IRoute;
    } = {};
    routesAndBoardsMap: {
        [route: string]: {
            id: string,
            figmaId: string,
        }
    }= {};
    rootStore: IRootStore;

    constructor(rootStore: IRootStore) {
        this.rootStore = rootStore;

        makeAutoObservable(this);
    }

    loadRoute = (id: string, channelId: EChannel) => {
        api.getRoute(id)
            .then(action(this.loadRouteSuccess(channelId)))
            .catch(e => this.rootStore.errorsStore.addError(e));
    };

    loadRouteSuccess = (channelId: EChannel) => (route: IRoute) => {
        const routesMap = getMapRoutAndBoardId(route.routes);

        this.routes[channelId] = route;
        this.routesAndBoardsMap = Object.assign(this.routesAndBoardsMap, routesMap);
    };
}

export default RoutesStore;
